<template>
    <div class="row justify-content-center px-3">
        <div class="col-md-12 mx-auto pt-3">
            <table class="mx-auto mb-3" style="width:100%;">
                <tbody class="colorabc1">
                    <tr>
                        <td style="width:2%;">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                fill="currentColor"
                                class="bi bi-people-fill"
                                viewBox="0 0 16 16"
                            >
                                <path
                                    d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                                />
                                <path
                                    fill-rule="evenodd"
                                    d="M5.216 14A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216z"
                                />
                                <path
                                    d="M4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
                                />
                            </svg>
                        </td>
                        <td style="width:98%;">
                            <p class="abc-title-main mb-0 pt-1">
                                {{ __("traductionpro.staff") }}
                            </p>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-md-12 mx-auto dashboardstyle pt-0">
            <table class="mx-auto text-center abc-table" style="width:100%;">
                <thead class="abc-title-table">
                    <tr style="border-bottom:solid 1px #3A9AF3;">
                        <th
                            class="py-3"
                            style="width: 5%; vertical-align:middle;"
                        >
                            id
                            <button
                                style="text-align:center;"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri ascendant"
                                v-on:click="idSortAsc"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="9"
                                    height="9"
                                    fill="rgb(107, 107, 107)"
                                    class="bi bi-caret-up-fill"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"
                                    />
                                </svg>
                            </button>
                            <button
                                style="text-align:center"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri descendant"
                                v-on:click="idSortDsc"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="9"
                                    height="9"
                                    fill="rgb(107, 107, 107)"
                                    class="bi bi-caret-down-fill"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"
                                    />
                                </svg>
                            </button>
                        </th>
                        <th style="width: 19%; vertical-align:middle;">
                            {{ __("traductionview.nomnom") }}
                            <button
                                style="text-align:center;"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri ascendant"
                                v-on:click="projectSortAsc"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="9"
                                    height="9"
                                    fill="rgb(107, 107, 107)"
                                    class="bi bi-caret-up-fill"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"
                                    />
                                </svg>
                            </button>
                            <button
                                style="text-align:center"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri descendant"
                                v-on:click="projectSortDsc"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="9"
                                    height="9"
                                    fill="rgb(107, 107, 107)"
                                    class="bi bi-caret-down-fill"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"
                                    />
                                </svg>
                            </button>
                        </th>
                        <th style="width: 19%; vertical-align:middle;">
                            {{ __("traductionview.titrejob") }}
                        </th>
                        <th style="width: 19%; vertical-align:middle;">
                            {{ __("traductionview.numerotel") }}
                        </th>
                        <th style="width: 19%; vertical-align:middle;">
                            {{ __("traductionview.email") }}
                        </th>
                        <th style="width: 19%; vertical-align:middle;">
                            {{ __("traductionview.datearriveee") }}
                            <button
                                style="text-align:center;"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri ascendant"
                                v-on:click="dateSortAsc"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="9"
                                    height="9"
                                    fill="rgb(107, 107, 107)"
                                    class="bi bi-caret-up-fill"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"
                                    />
                                </svg>
                            </button>
                            <button
                                style="text-align:center"
                                type="button"
                                class="btn-sort"
                                aria-label="Tri descendant"
                                v-on:click="dateSortDsc"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="9"
                                    height="9"
                                    fill="rgb(107, 107, 107)"
                                    class="bi bi-caret-down-fill"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"
                                    />
                                </svg>
                            </button>
                        </th>
                    </tr>
                </thead>
                <tbody
                    id="ongoingproject"
                    style="font-size: 11px; overflow:auto; display:block; max-height:600px;"
                >
                    <tr
                        v-for="(customer, index) in customs"
                        :key="index"
                        style="border-bottom:solid 1px rgb(206,206,206);"
                    >
                        <td
                            class="py-3"
                            style="vertical-align: middle; width: 5%;"
                        >
                            {{ customer.id }}
                        </td>
                        <td style="vertical-align: middle; width: 19%;">
                            <a
                                :href="'/app/home/' + customer.id"
                                class="font-weight-bold colorabc1 triggerspinner"
                            >
                                <p class="mb-0">
                                    {{ customer.firstname }}
                                    {{ customer.lastname }}
                                </p>
                            </a>
                        </td>
                        <td style="vertical-align: middle; width: 19%;">
                            <p class="mb-0">{{ customer.title }}</p>
                        </td>
                        <td style="vertical-align: middle; width: 19%;">
                            <p class="mb-0">{{ customer.phone }}</p>
                        </td>
                        <td style="vertical-align: middle; width: 19%;">
                            <p class="mb-0">{{ customer.email }}</p>
                        </td>
                        <td style="vertical-align: middle; width: 19%;">
                            {{ customer.arrival_date }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    props: ["customers", "token", "route"],

    data() {
        return {
            customs: []
        };
    },

    mounted() {
        const customersArray = Object.values(this.customers);
        customersArray.forEach(customer => {
            this.customs.push(customer);
        });
    },

    methods: {
        projectSortAsc() {
            this.customs = this.customs.sort(function(a, b) {
                if (a.firstname < b.firstname) {
                    return -1;
                } else if (a.firstname > b.firstname) {
                    return 1;
                } else {
                    return 0;
                }
            });
        },

        projectSortDsc() {
            this.customs = this.customs.sort(function(a, b) {
                if (a.firstname > b.firstname) {
                    return -1;
                } else if (a.firstname < b.firstname) {
                    return 1;
                } else {
                    return 0;
                }
            });
        },
        idSortAsc() {
            this.customs = this.customs.sort(function(a, b) {
                if (a.id < b.id) {
                    return -1;
                } else if (a.id > b.id) {
                    return 1;
                } else {
                    return 0;
                }
            });
        },

        idSortDsc() {
            this.customs = this.customs.sort(function(a, b) {
                if (a.id > b.id) {
                    return -1;
                } else if (a.id < b.id) {
                    return 1;
                } else {
                    return 0;
                }
            });
        },
        dateSortAsc() {
            this.customs = this.customs.sort(function(a, b) {
                if (a.arrival_date < b.arrival_date) {
                    return -1;
                } else if (a.arrival_date > b.arrival_date) {
                    return 1;
                } else {
                    return 0;
                }
            });
        },

        dateSortDsc() {
            this.customs = this.customs.sort(function(a, b) {
                if (a.arrival_date > b.arrival_date) {
                    return -1;
                } else if (a.arrival_date < b.arrival_date) {
                    return 1;
                } else {
                    return 0;
                }
            });
        }
    }
};
</script>
